// What the SLT Register's filters narrow, shared by the table and the risk
// matrix so the two halves of the screen agree.
//
// The matrix places open risks only: an issue has already happened, so its
// probability means nothing, and an action has no score. It follows the search
// box, Mine and HR confidential only; the type pills and Show closed are about
// finding a row. The HR tier needs nothing here: the server never sends an HR
// item to somebody without it.

export function matchesSltFilters(item, { search = '', mine = false, userId = null, hrOnly = false } = {}) {
  const q = search.trim().toLowerCase();
  if (q && !`${item.reference || ''} ${item.title || ''} ${item.description || ''}`.toLowerCase().includes(q)) return false;
  if (mine && item.owner_id !== userId) return false;
  if (hrOnly && !item.hr_confidential) return false;
  return true;
}

export function sltMatrixRisks(items, filters) {
  return (items || []).filter(i => i.item_type === 'risk' && i.status === 'open' && matchesSltFilters(i, filters));
}
